import { createScreenStyles } from '../../theme/styles';
import { OPERATIONS_API_BASE } from '../../config/api';
import React, { useState, useEffect } from 'react';
import { View, Text, StyleSheet, Dimensions, ScrollView, TouchableHighlight} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { FontAwesome5 } from '@expo/vector-icons';
import { FontAwesome } from '@expo/vector-icons'; 

const screenWidth = Math.round(Dimensions.get('window').width);
const screenHeight = Math.round(Dimensions.get('window').height);

const preIndex = ( {route, navigation} ) => {

  const [count, setCount] = useState("");
  const [countPending, setCountPending] = useState("");
  const [loading, setLoading] = useState(false);
  const [apprdesp, setApprdesp] = useState(false);
  
  async function getStorageValue() {
    setApprdesp((await AsyncStorage.getItem("sfdespappr")) === "true");
  }

  async function loadCounts() {

    const iduser = await AsyncStorage.getItem('sfuserid');
    const apiUrl = `${OPERATIONS_API_BASE}/despesa/requester/count/` + iduser;

    const response = await fetch(
      apiUrl
    );

    const data = await response.json();
    
    setCount(data);

    const apiUrl2 = `${OPERATIONS_API_BASE}/despesa/pending/count/` + iduser;
    const response2 = await fetch(
      apiUrl2
    );

    const data2 = await response2.json();

    setCountPending(data2);

    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    getStorageValue();
    loadCounts();
  }, []);

  return (
  
        <ScrollView style={styles.content}>
          

          <View style={styles.row}>

            <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('Despesa', { despesaId: 0 })}}>
              <View style={styles.menuItem}>                  
                <FontAwesome name="file-o" size={36} color="#00004C" /> 
                <Text style={styles.textMenu}>Criar Novo</Text>
              </View>
            </TouchableHighlight>


            <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('DespesasIndex')}}>
              <View style={styles.menuItem}>                
                <FontAwesome5 name="credit-card" size={36} color="#00004C" /> 
                <Text style={styles.textMenu}>Meus Relatórios ({count})</Text>
              </View>
            </TouchableHighlight>
            
            { apprdesp &&
            <>
              <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('DespesasIndexPending')}}>
                <View style={styles.menuItem}>                
                  <FontAwesome5 name="clock" size={36} color="#00004C" /> 
                  <Text style={styles.textMenu}>Pendente Aprovação ({countPending})</Text>
                </View>
              </TouchableHighlight>

              <TouchableHighlight underlayColor={"transparent"} onPress={() => { navigation.navigate('DespesasIndexHistory')}}>
              <View style={styles.menuItem}>                
                <FontAwesome5 name="list-alt" size={36} color="#00004C" /> 
                <Text style={styles.textMenu}>Histórico</Text>
              </View>
              </TouchableHighlight>
            </>
            }

          </View>



        </ScrollView>


    );
}

var styles = createScreenStyles({


  backImageHeader: {
    width: '100%'
  },

  content: {
    paddingHorizontal: 16
  },

  contentContainer: {
    height:'100%',
    backgroundColor: '#f3f3f3',

  },


  menuItem:{
    width: '100%',
    minHeight: 124, paddingVertical: 20,
    marginBottom:20,
    flex:1,
    backgroundColor: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius:10,
    shadowColor: "#000",
    shadowOffset: {
      width: 8,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 3.49,
    elevation: 5,
  },

  textMenu: {
    fontSize:16,
    paddingTop:10,
    color: '#003c84',
    textAlign:'center'
  },

  row:{
    marginTop:20,
  }
});

export default preIndex;